export default __webpack_public_path__ + "static/media/analytics_testseries.1c25f367.png";